import * as React from 'react';
import * as I18n from 'i18n-js';
import FormGroup from '@reverbdotcom/commons/dist/components/form_group';
import { Category, findCategoryForDisplayName } from './category_data';

interface IProps {
  categories: Category[];
  selectedCategories: Category[];
  onAddCategory(uuid: string): void;
  onRemoveCategory(uuid: string): void;
}

export const MAXIMUM_SELECTABLE_CATEGORIES = 3;

export default function CombinedShippingCategories(props: IProps) {
  function atMaximumSelectedCategories() {
    return props.selectedCategories.length >= MAXIMUM_SELECTABLE_CATEGORIES;
  }

  function remainingCategories() {
    return props.categories.filter(cat => !props.selectedCategories.includes(cat));
  }

  function selectKey() {
    return (props.selectedCategories || []).length;
  }

  function onChange(e) {
    const { categories, onAddCategory } = props;
    const catName = e.target.value || '';
    const selectedCat = findCategoryForDisplayName(categories, catName);
    if (!selectedCat) { return null; }
    onAddCategory(selectedCat.uuid);
  }

  function renderSelectedCategories() {
    if (!props.selectedCategories || props.selectedCategories.length === 0) { return null; }

    return (
      <ul>
        {props.selectedCategories.map((cat) => (
          <li
            key={cat.uuid}
            className="search-pill mt-1"
          >
            <div className="search-pill__term">
              {cat.displayName}
              <button
                type="button"
                className="search-pill__remove"
                onClick={() => props.onRemoveCategory(cat.uuid)}
              />
            </div>
          </li>
        ))}
      </ul>
    );
  }

  function renderHiddenInputs() {
    return (
      <>
        {props.selectedCategories.map((cat) => (
          <input
            name="shipping_profile[combined_shipping_categories][]"
            key={cat.uuid}
            type="hidden"
            value={cat.uuid}
          />
        ))}
      </>
    );
  }

  return (
    <FormGroup
      label={I18n.t('discovery.dashboard.selling.shippingProfile.promoteOnListingsWithCategory')}
      inputName="catInput"
    >
      <input
        key={selectKey()}
        disabled={atMaximumSelectedCategories()}
        type="text"
        list="combined-shipping-select"
        id="catInput"
        onChange={onChange}
      />
      <datalist id="combined-shipping-select">
        {remainingCategories().map((cat) =>
          <option key={cat.uuid}>
            {cat.displayName}
          </option>,
        )}
      </datalist>
      {renderSelectedCategories()}
      {renderHiddenInputs()}
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/shipping_profiles/combined_shipping_categories.tsx